import Patch from "@shared/models/patch-updater"
import defaultPlanbookActivity from "./default-planbook-activity"
import defaultPlanbookContext from "./default-planbook-context"
import defaultPlanbookModels from "./default-planbook-models"

export const PLANBOOK_UNDELETE = {
  name: "PLANBOOK_UNDELETE",

  params: {
    planbookId: "string",
    classWebsiteIds: { type: "array", items: { type: "string" } },
    timestamp: "string",
    userId: "string",
  },

  patches(payload) {
    let planbookPatch = Patch.create("planbook", payload.planbookId).set(
      "attributes.deletedAt",
      null
    ).patch
    let userPatch = Patch.create("user", payload.userId)
      .push("relationships.planbooks.data", {
        id: payload.planbookId,
        type: "planbook",
      })
      .pull("relationships.deletedPlanbooks.data", {
        id: payload.planbookId,
        type: "planbook",
      })
      .push("attributes.planbookIds", payload.planbookId)
      .pull("attributes.deletedPlanbookIds", payload.planbookId).patch
    let classWebsitePatches = (payload.classWebsiteIds || []).map(
      (classWebsiteId) =>
        Patch.create("class-website", classWebsiteId).set("attributes.isDeleted", false).patch
    )

    return [planbookPatch, userPatch, ...classWebsitePatches]
  },

  undoPatches: null,

  narrative(payload, findFn, userId) {
    let models = defaultPlanbookModels(payload, findFn, userId, payload.planbookId)

    return {
      title: "Undeleted Planbook",
      titleForAnalytics: "Planbook - Undelete",
      description: `Undeleted ${models.planbook.attributes.title} planbook`,
      context: defaultPlanbookContext(payload, models),
      activity: defaultPlanbookActivity(payload, models),
    }
  },
}

export default PLANBOOK_UNDELETE
